/**
 * 实时 AI 试玩（测试工具，DEV 入口）：驱动真实 Engine 并渲染，
 * 用于肉眼验证平衡、死因与性能。三选一停留 0.8s 便于观察者读牌。
 */
import { STEP } from '../core/loop';
import type { InputState } from '../core/types';
import type { Engine } from './engine';
import { AiBrain, type Persona } from './ai-policy';

const CARD_READ = 0.8;

export class AiTester {
  active = false;
  persona: Persona = 'conservative';
  private brain: AiBrain | null = null;
  private levelWait = CARD_READ;

  attach(
    btn: HTMLElement, badge: HTMLElement,
    seedGetter: () => number, onStart: () => void,
  ): void {
    btn.classList.remove('hidden');
    btn.addEventListener('click', () => {
      onStart();
      this.brain = new AiBrain((seedGetter() ^ 0xa17e5) >>> 0);
      this.active = true;
      this.levelWait = CARD_READ;
      badge.classList.remove('hidden');
    });
  }

  stop(badge?: HTMLElement): void {
    this.active = false;
    badge?.classList.add('hidden');
  }

  /** 每逻辑步前调用：levelup 时延迟自动选牌，playing 时返回策略输入。 */
  drive(engine: Engine): InputState {
    this.brain?.tick(STEP);
    if (engine.phase === 'levelup') {
      this.levelWait -= STEP;
      if (this.levelWait <= 0 && this.brain) {
        engine.chooseUpgrade(this.brain.chooseUpgrade(this.persona, engine));
        this.levelWait = CARD_READ;
      }
      return { moveX: 0, moveY: 0 };
    }
    this.levelWait = CARD_READ;
    return this.brain
      ? this.brain.chooseInput(this.persona, engine)
      : { moveX: 0, moveY: 0 };
  }
}
